module.exports = __webpack_public_path__ + "img/wt-world.b37d583f.png";